import {performHttpRequest} from "../http";

export async function postWfst(category, data) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/openapi/' + window.websiteName + '/' + window.categoryName + '/mutation',
        'POST',
        data
    )
}
